import React, { useEffect, memo, Fragment } from 'react';
import { Link } from 'react-router-dom';
import VerticalNav from '../SidebarStyle/vertical-nav';
import Scrollbar from "smooth-scrollbar";
import * as SettingSelector from "../../../../store/setting/selectors";
import { useSelector } from "react-redux";
import Logo from '../../components/logo';

const Sidebar = memo((props) => {
    const sidebarColor = useSelector(SettingSelector.sidebar_color);
    const sidebarHide = useSelector(SettingSelector.sidebar_show);
    const sidebarType = useSelector(SettingSelector.sidebar_type);
    const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);

    const minisidebar = () => {
        document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
    };

    useEffect(() => {
        Scrollbar.init(document.querySelector("#my-scrollbar"));

        window.addEventListener("resize", () => {
            const tabs = document.querySelectorAll(".nav");
            const sidebarResponsive = document.querySelector(
                '[data-sidebar="responsive"]'
            );
            if (window.innerWidth < 1201) {  // Changed from 1025 to 1201
                Array.from(tabs, (elem) => {
                    if (
                        !elem.classList.contains("flex-column") &&
                        elem.classList.contains("nav-tabs") &&
                        elem.classList.contains("nav-pills")
                    ) {
                        elem.classList.add("flex-column", "on-resize");
                    }
                    return elem.classList.add("flex-column", "on-resize");
                });
                if (sidebarResponsive !== null) {
                    if (!sidebarResponsive.classList.contains("sidebar-mini")) {
                        sidebarResponsive.classList.add("sidebar-mini", "on-resize");
                    }
                }
            } else {
                Array.from(tabs, (elem) => {
                    if (elem.classList.contains("on-resize")) {
                        elem.classList.remove("flex-column", "on-resize");
                    }
                    return elem.classList.remove("flex-column", "on-resize");
                });
                if (sidebarResponsive !== null) {
                    if (
                        sidebarResponsive.classList.contains("sidebar-mini") &&
                        sidebarResponsive.classList.contains("on-resize")
                    ) {
                        sidebarResponsive.classList.remove("sidebar-mini", "on-resize");
                    }
                }
            }
        });
    });

    return (
        <Fragment>
            <style>
                {`
                    .sidebar-toggle {
                        background-color: transparent !important;
                    }

                    .sidebar-toggle:hover {
                        background-color: #f0f0f0;
                    }

                    /* Logo switching styles */
                    .logo-full {
                        display: block;
                    }
                    
                    .logo-mini {
                        display: none;
                    }
                    
                    /* When sidebar is collapsed, show mini logo and hide full logo */
                    .sidebar-mini .logo-full {
                        display: none;
                    }
                    
                    .sidebar-mini .logo-mini {
                        display: block;
                    }
                    
                    /* Position the mini logo to the left (not centered) */
                    .sidebar-mini .navbar-brand {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        width: 100%;
                        padding-left: 15px;
                    }
                    
                    /* Make toggle icon smaller when sidebar is collapsed */
                    .sidebar-toggle .icon svg {
                        transition: all 0.3s ease;
                    }
                    
                    .sidebar-mini .sidebar-toggle .icon svg {
                        width: 16px;
                        height: 16px;
                    }
                `}
            </style>
            <aside
                className={`${sidebarColor} ${sidebarType.join(" ")} ${sidebarMenuStyle} ${
                    sidebarHide.join(" ") ? "sidebar-none" : "sidebar"
                } sidebar-base`}
                data-sidebar="responsive"
            >
                <div className="sidebar-header d-flex align-items-center justify-content-start" style={{ height: "65px" }}>
                    <Link to="/dashboard" className="navbar-brand">
                        <Logo />
                    </Link>
                    <div
                        className="sidebar-toggle ms-auto me-3"
                        data-toggle="sidebar"
                        data-active="true"
                        onClick={minisidebar}
                        style={{ 
                            cursor: 'pointer',
                            padding: '8px',
                            borderRadius: '50%',
                            transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#f0f0f0';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                    >
                        <i className="icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <svg
                                width="20"
                                className="icon-20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 5H20"
                                    stroke="#2c475f"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                ></path>
                                <path
                                    d="M4 12H20"
                                    stroke="#2c475f"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                ></path>
                                <path
                                    d="M4 19H20"
                                    stroke="#2c475f"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                ></path>
                                <path
                                    d="M17 17L20 12L17 7"
                                    stroke="#2c475f"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                ></path>
                            </svg>
                        </i>
                    </div>
                </div>
                <div
                    className="pt-0 sidebar-body data-scrollbar"
                    data-scroll="1"
                    id="my-scrollbar"
                >
                    <div className="sidebar-list navbar-collapse" id="sidebar">
                        <VerticalNav />
                    </div>
                </div>
                <div className="sidebar-footer"></div>
            </aside>
        </Fragment>
    );
});

export default Sidebar;